<template>
  <div>
    <v-card class="elevation-1 mt-4">
      <v-card-title class="py-2">
        <span class="primary--text">Supplier settings</span>
        <v-spacer></v-spacer>
        <v-switch
          id="is_a_supplier_switch"
          hide-details
          class="text-xs-center my-0"
          style="flex: none;"
          :label="`${newCompany.name} is a Supplier`"
          @change="
            updateModel(
              'companyStore',
              'newCompany',
              'isSupplier',
              !newCompany.isSupplier
            )
          "
          :input-value="newCompany.isSupplier"
        />
      </v-card-title>

      <v-layout
        v-show="newCompany.isSupplier"
        wrap
        justify-space-between
        row
        px-4
      >
        <v-flex pa-2 md6>
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="supplier_types"
            :items="supplier_types"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'supplier_type_id',
                $event
              )
            "
            :value="newCompany.supplier.supplier_type_id"
            default="Products Supplier"
            background-color="white"
            label="Supplier Type"
          />
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_currencies')">
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            sm6
            id="supplier_currencies"
            :items="currencies"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'currency_ids',
                $event
              )
            "
            :value="newCompany.supplier.currency_ids"
            background-color="white"
            multiple
            label="Currencies"
          />
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_shipping_tracking_url')">
          <v-text-field
            hide_details
            label="Shipping Tracking Url for BL"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'shipping_tracking_url_bl',
                $event
              )
            "
            :value="newCompany.supplier.shipping_tracking_url_bl"
            background-color="white"
          >
            <v-tooltip slot="append" bottom>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>Shipping line's tracking url for BL.</span>
              <br />
              <span
                v-text="
                  'Write the full URL and put {{reference}} where the reference ID is for interpolation'
                "
              ></span>
            </v-tooltip>
          </v-text-field>
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_shipping_tracking_url')">
          <v-text-field
            hide_details
            label="Shipping Tracking Url for Booking"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'shipping_tracking_url_booking',
                $event
              )
            "
            :value="newCompany.supplier.shipping_tracking_url_booking"
            background-color="white"
          >
            <v-tooltip slot="append" bottom>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>Shipping line's tracking url for Booking.</span>
              <br />
              <span
                v-text="
                  'Write the full URL and put {{reference}} where the reference ID is for interpolation'
                "
              ></span>
            </v-tooltip>
          </v-text-field>
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_shipping_tracking_url')">
          <v-text-field
            hide_details
            label="Shipping Tracking Url for a Shipment Unit"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'shipping_tracking_url_shipment_unit',
                $event
              )
            "
            :value="newCompany.supplier.shipping_tracking_url_shipment_unit"
            background-color="white"
          >
            <v-tooltip slot="append" bottom>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>Shipping line's tracking url for Shipment unit.</span>
              <br />
              <span
                v-text="
                  'Write the full URL and put {{reference}} where the reference ID is for interpolation'
                "
              ></span>
            </v-tooltip>
          </v-text-field>
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_payment_terms')">
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="supplier_payment_terms"
            :items="paymentTerms"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'payment_term_ids',
                $event
              )
            "
            :value="newCompany.supplier.payment_term_ids"
            background-color="white"
            multiple
            label="Payment terms"
          />
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_shipments')">
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="supplier_shipments"
            :items="shipments"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'shipment_ids',
                $event
              )
            "
            :value="newCompany.supplier.shipment_ids"
            background-color="white"
            multiple
            label="Shipments"
          />
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_incoterms')">
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="supplier_incoterms"
            :items="incoterms"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'incoterm_ids',
                $event
              )
            "
            :value="newCompany.supplier.incoterm_ids"
            background-color="white"
            multiple
            label="Incoterms"
          />
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_origin_countries')">
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="supplier_countries"
            :items="countries"
            item-value="id"
            item-text="name"
            :value="newCompany.supplier.country_ids"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'country_ids',
                $event
              )
            "
            background-color="white"
            multiple
            label="Countries of Origin (of the products)"
          >
            <v-tooltip slot="append" left>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>Country in which the product has been produced.</span>
            </v-tooltip>
          </v-autocomplete>
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_shipping_companies')">
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="supplier_shipping_companies"
            :items="shippingCompanies"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'shipping_company_ids',
                $event
              )
            "
            :value="newCompany.supplier.shipping_company_ids"
            background-color="white"
            multiple
            label="Shipping companies"
          >
            <v-tooltip slot="append" left>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>
                Shipping companies usually used from this
                <strong>Origin.</strong>
              </span>
            </v-tooltip>
          </v-autocomplete>
        </v-flex>
        <v-flex pa-2 md6 v-if="isFieldNeeded('has_ports')">
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="supplier_ports"
            :items="ports"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'supplier'],
                'port_ids',
                $event
              )
            "
            :value="newCompany.supplier.port_ids"
            background-color="white"
            multiple
            label="POL (Port of Loading)"
          />
        </v-flex>
      </v-layout>
    </v-card>

    <v-expansion-panel class="expandPanel mt-4" expand v-model="expanded">
      <v-expansion-panel-content>
        <div slot="header">Select defaults additionnal informations</div>
        <v-flex xs12 sm12 md12 xl12 px-4 pt-2>
          <v-card flat>
            <integratedSearchBar
              :button_display="true"
              button_label="Select all"
              button_icon="select_all"
              v-bind:search.sync="search_addInfos"
              search_label="Search additionnal information..."
            />
            <v-data-table
              :headers="headers"
              hide-headers
              id="supplier_additional_informations"
              :items="additionalInformations"
              :search="search_addInfos"
              :pagination.sync="pagination"
              must-sort
              rows-per-page-text="Additionnal Informations per page"
            >
              <v-progress-linear
                slot="progress"
                color="blue"
                indeterminate
              ></v-progress-linear>

              <template slot="items" slot-scope="info">
                <v-flex pt-4>
                  <v-checkbox
                    ripple
                    flat
                    height="8"
                    @change="updateAdditionalInformations(info.item.id, $event)"
                    :label="info.item.name"
                    :input-value="
                      newCompany.supplier.additional_information_ids.includes(
                        info.item.id
                      )
                    "
                  ></v-checkbox>
                </v-flex>
                <v-divider></v-divider>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import integratedSearchBar from "../shared/integratedSearchBar";
export default {
  components: {
    integratedSearchBar,
  },
  data() {
    return {
      expanded: [false],
      pagination: {
        descending: false,
        sortBy: "name",
        rowsPerPage: -1,
      },
      headers: [
        {
          text: "",
          align: "left",
          value: "name",
        },
      ],
      search_addInfos: "",
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "additionalInformations",
      "additionalInformationsIds",
      "currencies",
      "ports",
      "portsFromCountry",
      "incoterms",
      "paymentTerms",
      "supplier_types",
      "shipments",
      "shippingCompanies",
      "countries",
    ]),
    ...mapGetters("companyStore", ["newCompany"]),
  },
  methods: {
    updateAdditionalInformations(item_id, value) {
      let list = this.newCompany.supplier.additional_information_ids;
      if (value == true) list = list.concat(item_id);
      else
        list = list.filter((e) => {
          return e !== item_id;
        });

      this.updateModel(
        "companyStore",
        ["newCompany", "supplier"],
        "additional_information_ids",
        list
      );
    },
    isFieldNeeded(boolean_name) {
      if (!this.newCompany.isSupplier) return false;
      if (!this.newCompany.supplier.supplier_type_id) return false;

      let supplier_type = this.supplier_types.find(
        (e) => e.id === this.newCompany.supplier.supplier_type_id
      );
      return supplier_type[boolean_name];
    },
    removeSupplierPort(item) {
      this.newCompany.supplier.port_ids = this.newCompany.supplier.port_ids.filter(
        (port) => port !== item.id
      );
    },
    selectAll() {
      if (
        this.newCompany.supplier.additional_information_ids.length ==
        this.additionalInformationsIds.length
      )
        this.updateModel(
          "companyStore",
          ["newCompany", "supplier"],
          "additional_information_ids",
          []
        );
      else
        this.updateModel(
          "companyStore",
          ["newCompany", "supplier"],
          "additional_information_ids",
          this.additionalInformationsIds
        );
    },
  },
};
</script>
